import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const ProductCard = ({ product, delay = 0 }) => (
  <FadeUp delay={delay} className="h-full">
    <a
      href={product.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`product-card-${product.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-3xl border border-forest/10 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
    >
      <div className="relative overflow-hidden">
        <img
          src={product.img}
          alt={product.name}
          className={`aspect-[4/3] w-full transition-transform duration-700 group-hover:scale-105 ${
            product.contain ? "bg-white object-contain p-4" : "object-cover"
          }`}
        />
        {product.fav && (
          <span className="absolute left-3 top-3 rounded-full bg-coral px-3.5 py-1.5 font-display text-[11px] font-semibold tracking-[0.15em] text-bone shadow-md">
            ❤️ FAV
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-extrabold tracking-tight text-ink">{product.name}</h3>
        <p className="mt-1 font-body text-sm font-medium text-coral">{product.flavor}</p>
        {product.description && (
          <p className="mt-2 flex-1 font-body text-sm font-light leading-relaxed text-ink/60">{product.description}</p>
        )}
        <span
          data-testid={`product-button-${product.id}`}
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-forest px-6 py-3.5 font-display text-xs font-bold tracking-[0.15em] text-bone transition-all duration-300 group-hover:bg-coral"
        >
          {product.button}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </a>
  </FadeUp>
);

export default ProductCard;
